import { render } from "./statisticsList.vue?vue&type=template&id=d0723ba8&scoped=true"
import script from "./statisticsList.vue?vue&type=script&lang=js"
export * from "./statisticsList.vue?vue&type=script&lang=js"

import "./statisticsList.vue?vue&type=style&index=0&id=d0723ba8&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0723ba8"]])

export default __exports__